// extracted by mini-css-extract-plugin
module.exports = {"text":"AdaptiveText_text__zwb_U"};